module.exports = __webpack_public_path__ + "img/0-44.df481b2c.jpg";